const mockWsReceived = (type = '', payload = {}) => ({
    type: `REDUX_WEBSOCKET::${type.toUpperCase()}`,
    payload,
})

export default mockWsReceived
